export default "__VITE_ASSET__MLpMi2KU__"